import { Stack } from '@fluentui/react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import OrderSwitcher from '../../../../../../../../../OrderSwitcher/OrderSwitcher';
import { TableOfObjectsContext } from '../../../../context';
import { ITableSortData } from '../../../../interfaces';
import { DefaultText, Tr } from '../../styles';
import { HeaderCellWrapper, Th, THead, UnitsText } from './styles';

/**
 * Шапка таблицы
 */
const Header = () => {
    const context = useContext(TableOfObjectsContext);
    const { t } = useTranslation();

    const handleOrderToggle = (data: ITableSortData) => {
        if (context?.storeTableSortDataTrans) {
            context.storeTableSortDataTrans(data);
        }
    };

    return (
        <THead>
            <Tr>
                <Th>
                    <DefaultText>{t('Name')}</DefaultText>
                </Th>
                {context?.selectedMetrics?.map((selectedMetric) => {
                    const currentMetric = context?.allMetrics?.find((element) => element.id === selectedMetric);
                    const orderingMain =
                        context?.tableSortData?.metricId === selectedMetric &&
                        context?.tableSortData?.periodType === 'mainPeriod'
                            ? context?.tableSortData.ordering
                            : 'none';

                    const orderingCompare =
                        context?.tableSortData?.metricId === selectedMetric &&
                        context?.tableSortData?.periodType === 'comaprePeriod'
                            ? context?.tableSortData.ordering
                            : 'none';
                    return (
                        <Th key={selectedMetric}>
                            <HeaderCellWrapper>
                                <OrderSwitcher
                                    handleOrderToggle={(data) =>
                                        handleOrderToggle({
                                            ...data,
                                            metricId: selectedMetric,
                                            periodType: data.id,
                                        })
                                    }
                                    ordering={orderingMain}
                                    id="mainPeriod"
                                />
                                <Stack>
                                    <DefaultText>{t(currentMetric?.text || selectedMetric)}</DefaultText>
                                    <UnitsText>{`(${t(currentMetric?.units || '')})`}</UnitsText>
                                </Stack>

                                <OrderSwitcher
                                    handleOrderToggle={(data) =>
                                        handleOrderToggle({
                                            ...data,
                                            metricId: selectedMetric,
                                            periodType: data.id,
                                        })
                                    }
                                    ordering={orderingCompare}
                                    id="comaprePeriod"
                                />
                            </HeaderCellWrapper>
                        </Th>
                    );
                })}
            </Tr>
        </THead>
    );
};

export default Header;
